import Controller, { OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FilterAPI } from '@philips-internal/oswald-ui-components';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import BaseController from '../../../BaseController';

import { EletronicPrescriptionsUtils } from '../../../../utils/eletronic-prescription-utils';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { FragmentNames, PatientPrescriptionsAllTabAliases } from '../../../../codegen';

interface HasParent { parent: DataContext }

@Controller({ component: PatientPrescriptionsAllTabAliases.PATIENT_PRESCRIPTIONS_ALL_TAB_LAYOUT, fragment: FragmentNames.ELETRONIC_SERVICE_PERSONAL_INFORMATION_ALL_TAB })
class PatientPrescriptionsAllTabController extends BaseController {

  @OnMount(PatientPrescriptionsAllTabAliases.FILTER_PRESCRIPTIONS)
  handleFilterMount(evt: MountEvent): void {
    const filter = evt.target as FilterAPI;
    const data = EletronicPrescriptionsUtils.getFilterInitialData(filter, this.getParent());
    filter.clear();
    filter.setData(data);
  }

  @OnBeforeSubmit(PatientPrescriptionsAllTabAliases.FILTER_PRESCRIPTIONS)
  handleBeforeFilterSubmit(evt: SubmitEvent): void {
    const record = evt.record;
    this.getParent().set({filterRecord: record});
  }

  private getParent(): DataContext {
    const contextWithParent = this.context as unknown as HasParent;
    return contextWithParent.parent;
  }
}

export default PatientPrescriptionsAllTabController;